import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["showMoreNews", "tablebodyNews"];

  connect() {
    this.pageNews = 1;
    this.perPage = 3;

    var hasMoreToLoadNews = true;
    if (this.tablebodyNewsTarget.dataset.newscount <= this.perPage) {
      hasMoreToLoadNews = false;
    }
    this._showButtonNews(hasMoreToLoadNews);
  }

  showMoreNews(e) {
    this._showButtonNews(false);
    this.pageNews += 1;

    fetch(`${this.showMoreNewsTarget.dataset.url}?page=${this.pageNews}`, {
      credentials: "same-origin"
    })
      .then(response => response.text())
      .then(res => {
        if (res) {
          this.tablebodyNewsTarget.insertAdjacentHTML("beforeend", res);
          this._showButtonNews(true);
          const newRowCount = this.tablebodyNewsTarget.lastElementChild.children.length;
          const newscount = this.tablebodyNewsTarget.dataset.newscount

          if (((this.pageNews - 1) * this.perPage + newRowCount) == newscount) {
            this._showButtonNews(false);
          }
        }
      });

    // Prevent hash from showing in URL
    e.preventDefault();
  }

  _showButtonNews(show) {
    this.showMoreNewsTarget.style.display = show ? "" : "none";
  }
}
